import moment from "moment";
import { useContext } from "react";
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Label,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import CircularLoader from "../../../components/loading/circularLoader";
import { roundLargeNumbers } from "../../../utils/formatNumber";
import { DashBoardContext } from "../contexts/DashBoardContext";
import { useDashBoardFinanceiroService } from "../contexts/DashBoardFinanceiroContext";
import { ChartContainer, LoadingContainer } from "../styles/DashBoard";
import { CashFlowToolTip } from "./ChartToolTips";

const CashFlowChart = () => {
  const { defaultIntervalPeriodLabel } = useContext(DashBoardContext);
  const { cashFlowChartInfo } = useDashBoardFinanceiroService();

  if (cashFlowChartInfo.isLoading)
    return (
      <LoadingContainer>
        <CircularLoader />
      </LoadingContainer>
    );

  return (
    <ChartContainer>
      <ResponsiveContainer height={350}>
        <ComposedChart
          width={500}
          height={400}
          data={cashFlowChartInfo.data}
          margin={{
            top: 15,
            right: 28,
            bottom: 42,
            left: 28,
          }}
        >
          <CartesianGrid stroke="#d0d0d0" strokeDasharray="5 5" />
          <XAxis
            dataKey="date"
            tickFormatter={(value) =>
              moment(value).format(
                defaultIntervalPeriodLabel[
                  cashFlowChartInfo?.groupPeriod || "day"
                ].strDateFormat
              )
            }
            angle={325}
            dy={15}
            dx={-15}
          >
            <Label
              dy={48}
              dx={-30}
              value={
                defaultIntervalPeriodLabel[
                  cashFlowChartInfo?.groupPeriod || "day"
                ].strInfo
              }
            />
          </XAxis>
          <YAxis
            yAxisId="left"
            axisLine={false}
            tickLine={false}
            type="number"
            tickFormatter={roundLargeNumbers}
          >
            <Label angle={270} dx={-52} value={"Valor Saldo (R$)"} />
          </YAxis>
          <YAxis
            yAxisId="right"
            axisLine={false}
            orientation="right"
            dx={8}
            tickLine={false}
            type="number"
            tickFormatter={roundLargeNumbers}
          >
            <Label angle={270} dx={52} value={"Valor Contas (R$)"} />
          </YAxis>
          <Tooltip
            content={
              <CashFlowToolTip
                strDateFormat={
                  defaultIntervalPeriodLabel[
                    cashFlowChartInfo?.groupPeriod || "day"
                  ].strDateFormat
                }
              />
            }
          />
          <Legend layout="horizontal" verticalAlign="top" align="center" />
          <Bar
            yAxisId="right"
            name="Contas Receber"
            dataKey="toReceive"
            barSize={18}
            fill="#3366cc"
          />
          <Bar
            yAxisId="right"
            name="Contas Pagar"
            dataKey="toPay"
            barSize={18}
            fill="#dc3a12"
          />
          <Line
            yAxisId="left"
            name="Saldo"
            dataKey="balance"
            type="monotone"
            stroke="#32a852"
          />
        </ComposedChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};

export default CashFlowChart;
